import React from 'react';
import {Card, Grid, Dropdown, Icon, Button} from 'semantic-ui-react';
import {getDropdownOptions} from '../../../../common/util/dropdown';
import WtsAgendaModal from '../componenteModalAgenda';
import WtsCalendarioTechDetailsModal from './../detallesComponente/calendarioTechDetailsModal';
import moment from 'moment';

const CalendarHeader = ({
  areas,
  areaSelected,
  onAreaChange,
  selectedCourseId,
  onClearSelection,
  courseToEdit,
  isModalOpen,
  onCloseModal,
  onOpenModal,
}) => (
  <Card raised fluid style={{'backgroundColor': 'transparent'}}>
    <div className="title-bar">
      <Grid verticalAlign="middle" padded>
        <Grid.Row>
          <Grid.Column width={15}>
            <div className="title"><h2>Programación de cursos de capacitación</h2></div>
          </Grid.Column>
          <Grid.Column width={1} textAlign="right">
            <WtsCalendarioTechDetailsModal />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={5}>
            <div className="ui fluid labeled input">
              <div className="ui label">Área de capacitación</div>
              <Dropdown
                fluid
                selection
                value={areaSelected?.id}
                onChange={(e, {value}) => onAreaChange(areas.find((x) => x.id === value))}
                options={getDropdownOptions(areas, 'id', 'description')}
                placeholder="Seleccione un área"
              />
            </div>
          </Grid.Column>
          <Grid.Column width={11} textAlign="right">
            <div style={{'display': 'inline-block', 'marginRight': '1em'}}>
              <Icon name="calendar" />
              <strong>Hoy:</strong> {moment().format('LL')}
            </div>
            {selectedCourseId && (
              <Button size="mini" color="blue" onClick={onClearSelection} style={{'marginRight': '1em'}}>
                Ver todos
              </Button>
            )}
            {onOpenModal && (
              <Button
                icon
                labelPosition="left"
                disabled={!areaSelected}
                onClick={onOpenModal}
                style={{
                  'backgroundColor': 'rgb(224, 224, 224)',
                  'color': '#000000',
                  'border': '0px solid #ffffff',
                  'marginRight': '5px',
                  'borderRadius': '2px',
                  'padding': '14px 14px',
                  'boxShadow': '0 1px 3px rgba(0,0,0,0.15)',
                }}
              >
                <Icon
                  name="plus circle"
                  style={{'color': '#21ba45', 'backgroundColor': 'rgb(224, 224, 224)', 'fontSize': '22px'}}
                />
                Añadir
              </Button>
            )}
            <WtsAgendaModal
              open={isModalOpen}
              onClose={onCloseModal}
              courseToEdit={courseToEdit}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  </Card>
);

export default CalendarHeader;
